export default __webpack_public_path__ + "static/media/565.af77116f.png";